<template>
  <div
    :class="[
      'bg-[#f0f0f4] rounded-lg flex flex-col items-center justify-center min-h-[370px] relative overflow-hidden',
      maxHeightClass
    ]"
  >
    <ProtectedImage
      v-if="biometryId"
      :biometry-id="biometryId"
      :rotation="rotation"
      img-class="w-full h-full object-contain rounded p-4 transition-transform"
      :data-testid="testid('evidence-image')"
      @click="handleOpenImage"
    />
    <template v-else>
      <v-icon size="64" color="#52526f">{{ mdiAccountEye }}</v-icon>
      <p class="text-sm text-[#52526f] mt-3">Toque para ampliar a evidência</p>
    </template>
    <div class="absolute top-2 right-2 z-[3] flex flex-col gap-2">
      <button
        :data-testid="testid('rotate-evidence-button')"
        class="w-9 h-9 flex items-center justify-center rounded-lg bg-white shadow hover:bg-gray-100 transition-colors"
        @click="handleRotate"
      >
        <v-icon size="20" color="#52526f">{{ mdiRotateRight }}</v-icon>
      </button>
    </div>
  </div>

  <ImageFullscreenOverlay
    v-if="isImageFullscreen && biometryId"
    v-model="isImageFullscreen"
    v-model:rotation="rotation"
    :biometry-id="biometryId"
  />
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { mdiAccountEye, mdiRotateRight } from '@mdi/js'
import ImageFullscreenOverlay from './ImageFullscreenOverlay.vue'
import ProtectedImage from './ProtectedImage.vue'

const props = withDefaults(
  defineProps<{
    biometryId: number | null
    testidPrefix?: string
    maxHeightClass?: string
  }>(),
  { testidPrefix: '', maxHeightClass: 'max-h-[500px]' }
)

const rotation = ref(0)
const isImageFullscreen = ref(false)

watch(
  () => props.biometryId,
  () => {
    rotation.value = 0
    isImageFullscreen.value = false
  }
)

function testid(name: string): string {
  return props.testidPrefix ? `${props.testidPrefix}-${name}` : name
}

function handleRotate() {
  rotation.value = (rotation.value + 90) % 360
}

function handleOpenImage() {
  if (props.biometryId) {
    isImageFullscreen.value = true
  }
}
</script>
